import createAsyncActionType from "../../../utilities/createAsyncActionType";

// GET
export const GET_CLIENT_PROFILE_ENTRY_DETAILS = createAsyncActionType(
  "GET_CLIENT_PROFILE_ENTRY_DETAILS"
);

// CLEAR
export const CLEAR_CLIENT_PROFILE_ENTRY_DETAILS =
  "CLEAR_CLIENT_PROFILE_ENTRY_DETAILS";

export const EXPORT_CLIENT_PROFILE_PDF_EXPORT = createAsyncActionType(
  "EXPORT_CLIENT_PROFILE_PDF_EXPORT"
);

export const CLEAR_EXPORT_CLIENT_PROFILE_PDF_EXPORT = createAsyncActionType(
  "CLEAR_EXPORT_CLIENT_PROFILE_PDF_EXPORT"
);



// WEBPACK FOOTER //
// ./src/features/client-profile/types/clientProfileEntryDetails.js